import { IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import { VyIcon } from '@weft/icons';
import type { FixedLineItem } from '@weft/types';
import { useDialog } from 'apps/app/src/hooks/use-dialog';
import { useMenu } from 'apps/app/src/hooks/use-menu';
import { DeleteLineItemDialog } from './delete-fixed-line-item-dialog-form/DeleteFixedLineItemDialog';
import { EditFixedLineItemDialogForm } from './edit-fixed-line-item-dialog-form/EditFixedLineItemDialogForm';

type ModifyFixedLineItemSectionProps = {
  invoiceId: string;
  customerId: string;
  lineItem: FixedLineItem;
};

export const ModifyFixedLineItemSection: React.FC<ModifyFixedLineItemSectionProps> = ({
  lineItem,
  invoiceId,
  customerId,
}) => {
  const { anchorElement, isOpen, handleMenuOpen, handleMenuClose } = useMenu();
  const editDialog = useDialog();
  const deleteDialog = useDialog();

  const openDialog = (dialog: ReturnType<typeof useDialog>) => {
    handleMenuClose();
    dialog.handleOpen();
  };

  return (
    <div>
      <IconButton
        size="medium"
        onClick={handleMenuOpen}
      >
        <VyIcon
          icon="DotsMenu"
          style={{ transform: 'rotate(90deg)' }}
        />
      </IconButton>

      <Menu
        anchorEl={anchorElement}
        open={isOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={() => openDialog(editDialog)}>
          <ListItemIcon>
            <VyIcon icon="Edit" />
          </ListItemIcon>
          <Typography
            fontSize="16px"
            fontWeight={350}
          >
            Edit Item
          </Typography>
        </MenuItem>

        <MenuItem onClick={() => openDialog(deleteDialog)}>
          <ListItemIcon>
            <VyIcon icon="Delete" />
          </ListItemIcon>
          <Typography
            fontSize="16px"
            fontWeight={350}
          >
            Delete Item
          </Typography>
        </MenuItem>
      </Menu>

      <DeleteLineItemDialog
        open={deleteDialog.isDialogOpen}
        handleClose={deleteDialog.handleClose}
        invoiceId={invoiceId}
        customerId={customerId}
        lineItem={lineItem}
      />
      <EditFixedLineItemDialogForm
        open={editDialog.isDialogOpen}
        handleClose={editDialog.handleClose}
        invoiceId={invoiceId}
        customerId={customerId}
        lineItem={lineItem}
      />
    </div>
  );
};
